<template>
  <div class="my-3">
    <label>Finalize User List</label>
    <div class="row p-3">
      <div class="col-sm-12 col-md-12 border p-3">
        <p>
          Deselect any users who do not belong on the list and click "Continue". You have selected
          <strong>{{ parseInt(FinalSelectedUsers.length).toLocaleString() }}</strong>
          users to receive points.
        </p>
      </div>
    </div>
    <a-table :columns="UserFields" :data-source="SelectedUsers" :pagination="pagination" bordered :row-key="(record) => record.id">
      <span slot="points" slot-scope="text, record">
        <span v-if="record.points < 0" class="badge badge-danger">{{
          record.points
            ? parseInt(record.points)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,')
            : '0.00'
        }}</span>
        <span v-else-if="record.points >= 0" class="badge badge-success">{{
          record.points
            ? parseInt(record.points)
                .toFixed(2)
                .replace(/\d(?=(\d{3})+\.)/g, '$&,')
            : '0.00'
        }}</span>
      </span>
      <span slot="choose" slot-scope="text, record">
        <b-form-checkbox
          v-model="FinalSelectedUsers"
          :name="record.clientId.toString()"
          :value="
            Object({
              ...record,
            })
          "
        >
        </b-form-checkbox>
      </span>
    </a-table>
    <b-button
      :to="{
        name: 'AdminAddPointsSetPoints',
        params: {
          programId: this.$route.params.programId,
          clientId: this.$route.params.clientId,
        },
      }"
      :disabled="!FinalSelectedUsers.length"
      variant="primary"
      class="m-2"
      @click="finalize()"
      >Continue</b-button
    >
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'AddPointsFinalizeListOfUsers',

  data() {
    return {
      sortBy: 'id',
      sortDesc: false,
      FinalSelectedUsers: [],
      pagination: {
        pageSize: 5,
        showTotal: (total, range) => (
          <div>
            <div>
              {range[0]}-{range[1]} of {total} items
            </div>
          </div>
        ),
        itemRender: (current, type, originalElement) => {
          const totalPages = Math.ceil(this.pagination.total / this.pagination.pageSize);
          if (type === 'next') {
            return (
              <div class="next-buttons">
                <li class="pagination-item">
                  <button type="button" class="btn btn-primary" disabled={totalPages === this.pagination.current}>
                    <font-awesome-icon icon="angle-right" class="m-0" />
                  </button>
                </li>
              </div>
            );
          }
          return originalElement;
        },
        hideOnSinglePage: true,
        total: this.$store.state.adminAddPoint.SelectedUsers.length,
      },
      UserFields: [
        {
          title: 'Username',
          key: 'userName',
          dataIndex: 'userName',
          sorter: (a, b) => a.userName.localeCompare(b.userName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'First Name',
          key: 'firstName',
          dataIndex: 'firstName',
          sorter: (a, b) => a.userName.localeCompare(b.firstName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'Last Name',
          key: 'lastName',
          dataIndex: 'lastName',
          sorter: (a, b) => a.userName.localeCompare(b.lastName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'Client Name',
          key: 'name',
          dataIndex: 'clientName',
          sorter: (a, b) => a.clientName.localeCompare(b.clientName),
          sortDirections: ['descend', 'ascend'],
        },
        {
          title: 'Points',
          key: 'points',
          dataIndex: 'points',
          scopedSlots: { customRender: 'points' },
          sorter: (a, b) => a.points - b.points,
          sortDirections: ['descend', 'ascend'],
          align: 'right',
        },
        {
          title: 'Select',
          key: 'choose',
          sortable: false,
          scopedSlots: { customRender: 'choose' },
        },
      ],
    };
  },
  methods: {
    finalize() {
      this.$store.dispatch('adminAddPoint/setSelectedUsers', this.FinalSelectedUsers);
    },
  },

  computed: {
    ...mapState({
      SelectedUsers: (state) => state.adminAddPoint.SelectedUsers,
    }),
  },
  watch: {
    '$store.state.adminAddPoint.SelectedUsers': function() {
      console.log('update');
      this.FinalSelectedUsers = this.$store.state.adminAddPoint.SelectedUsers;
      this.pagination = {
        ...this.pagination,
        total: this.$store.state.adminAddPoint.SelectedUsers.length,
        pageSize: this.$store.state.adminAddPoint.SelectedUsers.length,
      };
    },
  },
  mounted() {
    this.FinalSelectedUsers = this.$store.state.adminAddPoint.SelectedUsers;
    this.pagination = {
      ...this.pagination,
      total: this.$store.state.adminAddPoint.SelectedUsers.length,
      pageSize: this.$store.state.adminAddPoint.SelectedUsers.length,
    };
  },
};
</script>

<style lang="scss" scoped></style>
